import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DraftValidationModule, DecimalNumberDirectiveModule, WholeNumberDirectiveModule, YearDirectiveModule } from '@classifieds-sell/shared';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { TrademeCoreUiModule } from '@classifieds-sell/trademe-core-ui';
import {
    TgCheckboxModule,
    TgDateTimeFormatterModule,
    TgFormGroupModule,
    TgGridModule,
    TgIconBasicArrowRightModule,
    TgIconBasicTickFramedModule,
    TgIconStopModule,
    TgInputModule,
    TgRackModule,
    TgSelectModule
} from '@trademe/tangram';
import { TmDateComponent } from 'libs/trademe-core-ui/src/lib/tm-date/tm-date.component';
import { MotorsVehicleDetailsDetailsSectionComponent } from './motors-vehicle-details-details-section.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgIconBasicArrowRightModule,
        TgIconStopModule,
        TgIconBasicTickFramedModule,
        TgGridModule,
        TgSelectModule,
        TgInputModule,
        TgRackModule,
        TgFormGroupModule,
        LayoutModule,
        TrademeCoreUiModule,
        DraftValidationModule,
        TgDateTimeFormatterModule,
        TgCheckboxModule,
        WholeNumberDirectiveModule,
        DecimalNumberDirectiveModule,
        YearDirectiveModule
    ],
    declarations: [MotorsVehicleDetailsDetailsSectionComponent],
    providers: [TmDateComponent, MotorsDraftFacade],
    exports: [MotorsVehicleDetailsDetailsSectionComponent]
})
export class MotorsVehicleDetailsDetailsSectionModule {}
